import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { Box, xcss } from '@atlaskit/primitives';
import Select from '@atlaskit/select';
import { getDropDownMenuPosition } from '../../common/commonDropDownMenuProps';
import { messages } from './messages';
const containerStyles = xcss({
  display: 'flex',
  flexDirection: 'row'
});
const parentStyles = xcss({
  width: '50%',
  marginRight: 'space.100'
});
const childStyles = xcss({
  width: '50%'
});
export const EditCascadingDropdown = ({
  id,
  options,
  value,
  childOptions,
  childValue,
  loading,
  onChange,
  onChangeChild
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    xcss: containerStyles
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: parentStyles
  }, /*#__PURE__*/React.createElement(EditDropdown, {
    id: id,
    options: options,
    value: value !== null && value !== void 0 ? value : null,
    loading: loading,
    onChange: onChange,
    clearable: true
  })), /*#__PURE__*/React.createElement(Box, {
    xcss: childStyles
  }, /*#__PURE__*/React.createElement(EditDropdown, {
    id: `${id}-child`,
    options: childOptions,
    value: childValue !== null && childValue !== void 0 ? childValue : null,
    loading: loading,
    onChange: onChangeChild
  })));
};
const EditDropdown = ({
  id,
  options,
  value,
  loading,
  onChange,
  clearable = false
}) => {
  return /*#__PURE__*/React.createElement(Select, _extends({
    id: id,
    key: id,
    options: options,
    value: value !== null && value !== void 0 ? value : null,
    isLoading: loading,
    onChange: onChange,
    isSearchable: true,
    isClearable: clearable,
    noOptionsMessage: () => /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownNoOptions),
    placeholder: /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownSelect)
  }, getDropDownMenuPosition()));
};